import { ChangeDetectionStrategy, Component, computed, inject, input, resource } from '@angular/core';

import { VehicleImageService } from '../../services/vehicle-image/vehicle-image.service';

@Component({
  selector: 'cdf-vehicle-image',
  host: {
    class: 'd-flex',
  },
  template: `
    @if (imageUrl(); as imageUrl) {
      <img [src]="imageUrl" [alt]="vin()" class="mw-100 m-auto" />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleImageContainer {
  private readonly vehicleImageService = inject(VehicleImageService);

  readonly vin = input.required<string>();

  private readonly imageResource = resource({
    params: this.vin,
    loader: ({ params: vin }) => this.vehicleImageService.getVehicleImageUrl(vin),
  });

  protected readonly imageUrl = computed(() =>
    this.imageResource.hasValue() ? this.imageResource.value() : undefined,
  );
}
